/**
 * Formatter - Start Date
 */

// eslint-disable-next-line import/prefer-default-export
import { FormatDate } from './date'

// eslint-disable-next-line import/prefer-default-export
export const FormatStartDate = (startDate: string, format = 'MMM, dd') =>
  FormatDate(startDate, format).toUpperCase()
